@for (realisation of realisations; track realisation; let index = $index) {
    @let previousRealisation = realisations[index - 1]?.dayOff ? null : realisations[index - 1];
    @let gapBefore = previousRealisation?.enddate | minutesDiff: realisation.begindate;
    @let changedDate = (realisation.begindate | date: 'd') !== (realisations[index - 1]?.begindate | date: 'd');
    @let isNight =
        (changedDate && +(realisation.begindate | date: 'H') <= 4) ||
        (realisation.begindate | date: 'yyyy-MM-dd') !== (realisation.enddate | date: 'yyyy-MM-dd');

    <app-week-schedule-day
        [item]="realisation"
        [previousItem]="realisations[index - 1]"
        [nextItem]="realisations[index + 1]"
        [maxDate]="maxDate"
        [leaveHourtype]="realisation.leave_id ? realisation.hourtype : undefined"
        [leaveComment]="realisation.leave?.comment"
        (openItem)="openRealisation.emit(realisation)">
        @if ((realisation.dayOff && !realisation.dayOffReason) || changedDate || gapBefore > 120 || isNight) {
            <div class="day">
                @if (realisation.dayOff || !isNight) {
                    {{ realisation.begindate | date: 'EEEE d MMMM' }}
                } @else {
                    <span>Nacht</span> {{ realisation?.enddate | dateSub | date: 'EEE d MMM' }} <span>op</span>
                    {{ realisation?.enddate | date: 'EEE d MMM' }}
                }
            </div>
        }
        @if (!realisation.leave_id) {
            @if (!realisation.dayOff) {
                <div class="time">
                    {{ realisation.begindate | date: 'HH:mm' }} -
                    {{ realisation.enddate | date: 'HH:mm' }}
                </div>
            }
            @if (realisation.dayOff) {
                <div class="time dayoff">{{ realisation.dayOffReason ?? 'niet ingepland' }}</div>
            }
            @if (!realisation.dayOff && realisation.begindate < maxDate) {
                <div class="project">
                    <b>{{ realisation.hourtype | hourtype }}</b>
                    Project
                    {{
                        realisation.planning?.afas_project_id ??
                            realisation.afas_project_id ??
                            realisation?.user_planning?.project?.afas_project_id
                    }}
                    - {{ realisation.project?.name ?? realisation.planning?.project?.name }}<br />
                    <b>{{
                        realisation?.project?.location ??
                            realisation?.user_planning?.project?.location ??
                            realisation?.planning?.location ??
                            ''
                    }}</b
                    ><br />
                    @if (realisation.planning_has?.comment) {
                        <i>{{ realisation.planning_has.comment }}<br /></i>
                    }
                    {{
                        realisation.planning_has?.transport_worksite ??
                            realisation.planning_has?.transport_destination ??
                            realisation.planning_has?.transport_origin
                    }}
                </div>
            }
        }
    </app-week-schedule-day>
}
